/**
 * CreditsGuard — global axios interceptor: any HTTP 402 (insufficient
 * credits) opens a blocking modal with a shortcut to the Credits Store.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Coins } from "lucide-react";
import { useLang } from "../i18n/LangContext";

export default function CreditsGuard() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const isPt = lang === "pt";
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const id = axios.interceptors.response.use(
      (r) => r,
      (err) => {
        if (err?.response?.status === 402) setOpen(true);
        return Promise.reject(err);
      });
    return () => axios.interceptors.response.eject(id);
  }, []);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[90] bg-black/55 flex items-center justify-center p-4"
      onClick={() => setOpen(false)} data-testid="insufficient-credits-modal">
      <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full p-6 text-center"
        onClick={(e) => e.stopPropagation()}>
        <div className="w-12 h-12 rounded-full bg-[#FEF3C7] text-[#B45309] flex items-center justify-center mx-auto mb-3">
          <Coins className="w-6 h-6" />
        </div>
        <h3 className="text-[16px] font-extrabold text-[#111827] mb-1.5">
          {isPt ? "Saldo Insuficiente" : "Insufficient Balance"}
        </h3>
        <p className="text-[12.5px] text-[#6B7280] mb-4">
          {isPt
            ? "Seus créditos acabaram. Faça um top-up na Loja de Créditos ou aguarde a renovação do plano para continuar usando a Claire e o Auto Pilot."
            : "You're out of credits. Top up in the Credits Store or wait for plan renewal to keep using Claire and Auto Pilot."}
        </p>
        <div className="flex gap-2">
          <button type="button" data-testid="icm-store-btn"
            onClick={() => { setOpen(false); navigate("/billing/history"); }}
            className="flex-1 h-10 rounded-lg bg-[#C9A24E] text-[#1A1A2E] text-[12.5px] font-extrabold hover:brightness-110">
            {isPt ? "Ir para a Loja de Créditos" : "Go to Credits Store"}
          </button>
          <button type="button" onClick={() => setOpen(false)}
            className="h-10 px-4 rounded-lg border border-[#E5E7EB] text-[12px] font-semibold text-[#6B7280]">
            {isPt ? "Fechar" : "Close"}
          </button>
        </div>
      </div>
    </div>
  );
}
